import React, { useEffect } from "react";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
import { Link } from "react-router-dom";

const HomePage = () => {
  useEffect(() => {
    const swiper = new Swiper(".financ-swiper", {
      slidesPerView: 1,
      spaceBetween: 15,
      autoplay: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: false,
      breakpoints: {
        768: { slidesPerView: 2, spaceBetween: 30 },
        992: { slidesPerView: 3, spaceBetween: 30 },
      },
    });

    return () => swiper.destroy(true, true); // cleanup
  }, []);
  useEffect(() => {
    const swiper = new Swiper(".h3-partner_slider", {
      slidesPerView: 2,
      spaceBetween: 15,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: { slidesPerView: 3, spaceBetween: 30 },
        992: { slidesPerView: 6, spaceBetween: 30 },
      },
    });

    return () => swiper.destroy(true, true); // cleanup
  }, []);

  return (
    <main>
      <div data-aos="fade-up"
                  data-aos-duration={1000} className="theme-container mx-auto">
        <section className="bg-[#FCF8F1] bg-opacity-30 py-10 sm:py-16">
          <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div className="grid items-center grid-cols-1 gap-12 lg:grid-cols-2">
              <div>
                <p className="text-base font-semibold tracking-wider text-[#1B467D] uppercase">
                  Your Health, Just One Click Away
                </p>
                <h1 className="mt-2 text-[65px] max-md:text-[3.2rem] leading-[1.2em] md:max-w-[500px] font-bold text-black lg:mt-8">
                  Instant Access to Quality Healthcare
                </h1>
                <p className="mt-4 text-base text-black lg:mt-8 sm:text-xl">
                  Welcome to One Click Doctor, your trusted partner in
                  preventive healthcare. We offer convenient and cost-effective
                  OPD wellness plans that connect you with top doctors,
                  diagnostic services, and health benefits — all at your
                  fingertips.
                </p>
                <Link
                  to="/plans"
                  title=""
                  className="inline-flex items-center px-6 py-4 mt-8 font-semibold text-white transition-all duration-200 bg-[#1B467D] rounded-full  hover:bg-[#1464A5] focus:bg-[#1464A5]"
                  role="button"
                >
                  Explore Plans
                  <svg
                    className="w-6 h-6 ml-8 -mr-2"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </Link>

                <p className="mt-5 text-gray-600">
                  Already joined us?
                  <Link
                    to="https://oneclickdoctor.in/app/"
                    title=""
                    className="text-black font-semibold transition-all duration-200 ml-[4px] hover:underline"
                  >
                    Log in
                  </Link>
                </p>
              </div>
              <div>
                <img className="w-full" src="assets/img/hero-img.png" alt="" />
              </div>
            </div>
          </div>
        </section>
      </div>

      <section className="service-area w-full lg:py-[120px] py-[60px]">
        <div className="theme-container mx-auto h-full items-center">
          <div className="w-full grid xl:grid-cols-2 grid-cols-1 gap-[60px] xl:gap-0 items-center">
            <div className="grid-item">
              <h2 className="headline-default text-[#000000] mb-5">
                Safeguarding your <br />
                future today
              </h2>
              <p className="text-base text-[#000000] mb-14 pr-[60px]">
                Your health is your most valuable asset — and protecting it
                starts now. At One Click Doctor, we believe that proactive care
                today leads to a healthier, stress-free tomorrow. Waiting for
                illness to strike before seeking help can be costly, both
                financially and physically. That’s why we focus on preventive
                outpatient care, making everyday healthcare more accessible,
                affordable, and effective.
              </p>
              <div>
                <Link
                  to="/plans"
                  title=""
                  className="inline-flex items-center px-6 py-4 mt-8 font-semibold text-white transition-all duration-200 bg-[#1B467D] rounded-full  hover:bg-[#1464A5] focus:bg-[#1464A5]"
                  role="button"
                >
                  Explore Plans
                  <svg
                    className="w-6 h-6 ml-8 -mr-2"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </Link>
              </div>
            </div>
            <div className="grid-item">
              <div className="grid sm:grid-cols-2 grid-cols-1 sm:gap-[30px] gap-5">
                <div
                  data-aos="fade-up"
                  data-aos-duration={1000}
                  className="service-item p-[30px] rounded-[20px] bg-white shadow-md group"
                >
                  <div className="flex justify-center mb-5">
                    <div className="w-[60px] h-[60px] rounded flex justify-center items-center">
                      <img src="assets/img/teleconsult.svg" alt="" />
                    </div>
                  </div>
                  <h2 className="text-lg leading-7 font-bold spline-sans text-center text-primary-900 mb-5 ">
                    Unlimited Tele-consultations
                  </h2>
                  <p className="text-base leading-7 text-center text-primary-100 font-medium">
                    Talk to doctors anytime, anywhere with unlimited virtual
                    consultations — no clinic visits needed.
                  </p>
                </div>
                <div
                  data-aos="fade-up"
                  data-aos-duration={1000}
                  className="service-item p-[30px] rounded-[20px] bg-white shadow-md group"
                >
                  <div className="flex justify-center mb-5">
                    <div className="w-[60px] h-[60px] rounded flex justify-center items-center">
                      <img src="assets/img/diagnostics.svg" alt="" />
                    </div>
                  </div>
                  <h2 className="text-lg leading-7 font-bold spline-sans text-center text-primary-900 mb-5 ">
                    Diagnostic <br />
                    Wallet
                  </h2>
                  <p className="text-base leading-7 text-center text-primary-100 font-medium">
                    Get a prepaid diagnostic wallet to cover lab tests at
                    partnered centers — easy, cashless, and discounted.
                  </p>
                </div>
                <div
                  data-aos="fade-up"
                  data-aos-duration={1000}
                  className="service-item p-[30px] rounded-[20px] bg-white shadow-md group"
                >
                  <div className="flex justify-center mb-5">
                    <div className="w-[60px] h-[60px] rounded flex justify-center items-center">
                      <img src="assets/img/pharmacy.svg" alt="" />
                    </div>
                  </div>
                  <h2 className="text-lg leading-7 font-bold spline-sans text-center text-primary-900 mb-5 ">
                    Pharmacy <br />
                    Benefits
                  </h2>
                  <p className="text-base leading-7 text-center text-primary-100 font-medium">
                    Save on medicines with partner pharmacies — affordable care
                    for long-term needs.
                  </p>
                </div>
                <div
                  data-aos="fade-up"
                  data-aos-duration={1000}
                  className="service-item p-[30px] rounded-[20px] bg-white shadow-md group"
                >
                  <div className="flex justify-center mb-5">
                    <div className="w-[60px] h-[60px] rounded flex justify-center items-center">
                      <img src="assets/img/coverage.svg" alt="" />
                    </div>
                  </div>
                  <h2 className="text-lg leading-7 font-bold spline-sans text-center text-primary-900 mb-5 ">
                    Family <br />
                    Coverage
                  </h2>
                  <p className="text-base leading-7 text-center text-primary-100 font-medium">
                    Protect your loved ones with coverage for up to 4 family
                    members under all wellness plan.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-10 bg-white sm:py-16 lg:py-24">
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-3xl font-bold leading-tight text-black sm:text-4xl lg:text-5xl">
              How does it work?
            </h2>
            <p className="max-w-lg mx-auto mt-4 text-base leading-relaxed text-gray-600">
              Getting started with One Click Doctor is quick, easy, and
              completely digital. Here’s how you can take control of your health
              in just a few simple steps:
            </p>
          </div>
          <div className="relative mt-12 lg:mt-20">
            <div className="absolute inset-x-0 hidden xl:px-44 top-2 md:block md:px-20 lg:px-28">
              <img data-aos="fade"
                  data-aos-duration={1000}
                className="w-full"
                src="https://cdn.rareblocks.xyz/collection/celebration/images/steps/2/curved-dotted-line.svg"
                alt=""
              />
            </div>
            <div className="relative grid grid-cols-1 text-center gap-y-12 md:grid-cols-3 gap-x-12">
              <div data-aos="fade-left"
                  data-aos-duration={1000}>
                <div className="flex items-center justify-center w-16 h-16 mx-auto bg-white border-2 border-gray-200 rounded-full shadow">
                  <span className="text-xl font-semibold text-gray-700">1</span>
                </div>
                <h3 className="mt-6 text-xl font-semibold leading-tight text-black md:mt-10">
                  Choose a Plan
                </h3>
                <p className="mt-4 text-base text-gray-600 md:px-8">
                  Select the OPD wellness plan that suits your individual or
                  family needs.
                </p>
              </div>
              <div data-aos="fade-left"
                  data-aos-duration={1000}>
                <div className="flex items-center justify-center w-16 h-16 mx-auto bg-white border-2 border-gray-200 rounded-full shadow">
                  <span className="text-xl font-semibold text-gray-700">2</span>
                </div>
                <h3 className="mt-6 text-xl font-semibold leading-tight text-black md:mt-10">
                  Log Into PWA
                </h3>
                <p className="mt-4 text-base text-gray-600 md:px-8">
                  Register online in minutes — no paperwork, no waiting.
                </p>
              </div>
              <div data-aos="fade-left"
                  data-aos-duration={1000}>
                <div className="flex items-center justify-center w-16 h-16 mx-auto bg-white border-2 border-gray-200 rounded-full shadow">
                  <span className="text-xl font-semibold text-gray-700">3</span>
                </div>
                <h3 className="mt-6 text-xl font-semibold leading-tight text-black md:mt-10">
                  Book Services
                </h3>
                <p className="mt-4 text-base text-gray-600 md:px-8">
                  Need a doctor, lab test, or medicine? Booking is just a click
                  away.
                </p>
                {/*  */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/*      progress*/}
      <section className="progress-step pt-[40px]">
        <div className="progress-step-wrapper py-[60px]">
          <div className="theme-container mx-auto">
            <h2 className="text-center headline-default text-black lg:mb-[60px] mb-[30px]">
              Why Choose Us
            </h2>
            <div className="grid lg:grid-cols-4 sm:grid-cols-2 sm:gap-[30px] gap-5">
              <div
                data-aos="fade-left"
                data-aos-duration={1000}
                data-aos-delay={100}
                className="item p-[30px] bg-white rounded"
              >
                <div className="flex justify-between items-center mb-5">
                  <div className="w-[60px] h-[60px] rounded-full bg-[#e2efff] flex items-center justify-center">
                    <img src="assets/img/progress-1.svg" alt="progress" />
                  </div>
                  <h2 className="counter spline-sans">01</h2>
                </div>
                <h2 className="xl:text-lg text-md font-bold spline-sans text-gray-700 mb-5">
                  Transparent Pricing
                </h2>
                <p className="xl:text-base text-sm xl:leading-7 text-primary-100 font-medium">
                  No hidden fees or fine print
                </p>
              </div>
              <div
                data-aos="fade-left"
                data-aos-duration={1000}
                data-aos-delay={200}
                className="item p-[30px] bg-white rounded"
              >
                <div className="flex justify-between items-center mb-5">
                  <div className="w-[60px] h-[60px] rounded-full bg-[#e2efff] flex items-center justify-center">
                    <img src="assets/img/progress-2.svg" alt="progress" />
                  </div>
                  <h2 className="counter spline-sans">02</h2>
                </div>
                <h2 className="xl:text-lg text-md font-bold spline-sans text-gray-700 mb-5">
                  Pan-India Network
                </h2>
                <p className="xl:text-base text-sm xl:leading-7 text-primary-100 font-medium">
                  Thousands of partnered clinics, labs & pharmacies
                </p>
              </div>
              <div
                data-aos="fade-left"
                data-aos-duration={1000}
                data-aos-delay={300}
                className="item p-[30px] bg-white rounded"
              >
                <div className="flex justify-between items-center mb-5">
                  <div className="w-[60px] h-[60px] rounded-full bg-[#e2efff] flex items-center justify-center">
                    <img src="assets/img/progress-3.svg" alt="progress" />
                  </div>
                  <h2 className="counter spline-sans">03</h2>
                </div>
                <h2 className="xl:text-lg text-md font-bold spline-sans text-gray-700 mb-5">
                  Instant Access
                </h2>
                <p className="xl:text-base text-sm xl:leading-7 text-primary-100 font-medium">
                  Book, consult, and save within minutes
                </p>
              </div>
              <div
                data-aos="fade-left"
                data-aos-duration={1000}
                data-aos-delay={400}
                className="item p-[30px] bg-white rounded"
              >
                <div className="flex justify-between items-center mb-5">
                  <div className="w-[60px] h-[60px] rounded-full bg-[#e2efff] flex items-center justify-center">
                    <img src="assets/img/progress-4.svg" alt="progress" />
                  </div>
                  <h2 className="counter spline-sans">04</h2>
                </div>
                <h2 className="xl:text-lg text-md font-bold spline-sans text-gray-700 mb-5">
                  Customer Support
                </h2>
                <p className="xl:text-base text-sm xl:leading-7 text-primary-100 font-medium">
                  Real people, real-time help
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*      financial */}
      <section className="financ-section py-[60px]">
        <div className="theme-container mx-auto">
          <div className="w-full relative">
            <div className="lg:mb-[60px] mb-[30px]">
              <h2 className="headline-default text-black mb-4">
               Client Testimonials
              </h2>
              <p className="text-primary-100 font-medium">
                Hear what our members say about saving on healthcare with One
                Click Doctor
              </p>
            </div>
            <div data-aos="fade-up"
                  data-aos-duration={1000} className="financ-swiper overflow-hidden">
              <div className="swiper-wrapper mb-1">
                <div className="swiper-slide">
                  <div className="item sm:p-10 p-5 border border-primaryBorder rounded">
                    <div className="flex justify-between items-start mb-5">
                      <div className="flex space-x-5 items-center">
                        <div className="w-[80px] h-[80px] rounded-full">
                          <img
                            src="assets/img/testimonial-1.png"
                            alt=""
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center mb-2.5">
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                          </div>
                          <h2 className="text-gray-700 text-lg spline-sans font-semibold">
                            Ramesh Gupta
                          </h2>
                          <span className="text-base leading-7 text-primary-100 font-medium">
                            Chartered Accountant
                          </span>
                        </div>
                      </div>
                      <span className="sm:inline-block hidden">
                        <svg
                          width={35}
                          height={26}
                          viewBox="0 0 35 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M35 16.125C35 21.3594 30.7812 25.5 25.625 25.5H25C23.5938 25.5 22.5 24.4062 22.5 23C22.5 21.6719 23.5938 20.5 25 20.5H25.625C27.9688 20.5 30 18.5469 30 16.125V15.5H25C22.1875 15.5 20 13.3125 20 10.5V5.5C20 2.76562 22.1875 0.5 25 0.5H30C32.7344 0.5 35 2.76562 35 5.5V8V10.5V16.125ZM15 16.125C15 21.3594 10.7812 25.5 5.625 25.5H5C3.59375 25.5 2.5 24.4062 2.5 23C2.5 21.6719 3.59375 20.5 5 20.5H5.625C7.96875 20.5 10 18.5469 10 16.125V15.5H5C2.1875 15.5 0 13.3125 0 10.5V5.5C0 2.76562 2.1875 0.5 5 0.5H10C12.7344 0.5 15 2.76562 15 5.5V8V10.5V16.125Z"
                            fill="#1B467D"
                          />
                        </svg>
                      </span>
                    </div>
                    <p className="text-primary-100 font-medium text-base leading-7">
                      "One Click Doctor has made managing my family's health
                      easier than ever. Their family wellness plan is truly a
                      blessing!"
                    </p>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="item sm:p-10 p-5 border border-primaryBorder rounded">
                    <div className="flex justify-between items-start mb-5">
                      <div className="flex space-x-5 items-center">
                        <div className="w-[80px] h-[80px] rounded-full">
                          <img
                            src="assets/img/testimonial-2.png"
                            alt=""
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center mb-2.5">
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                          </div>
                          <h2 className="text-gray-700 text-lg spline-sans font-semibold">
                            Anjali Sharma
                          </h2>
                          <span className="text-base leading-7 text-primary-100 font-medium">
                            HR Manager
                          </span>
                        </div>
                      </div>
                      <span className="sm:inline-block hidden">
                        <svg
                          width={35}
                          height={26}
                          viewBox="0 0 35 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M35 16.125C35 21.3594 30.7812 25.5 25.625 25.5H25C23.5938 25.5 22.5 24.4062 22.5 23C22.5 21.6719 23.5938 20.5 25 20.5H25.625C27.9688 20.5 30 18.5469 30 16.125V15.5H25C22.1875 15.5 20 13.3125 20 10.5V5.5C20 2.76562 22.1875 0.5 25 0.5H30C32.7344 0.5 35 2.76562 35 5.5V8V10.5V16.125ZM15 16.125C15 21.3594 10.7812 25.5 5.625 25.5H5C3.59375 25.5 2.5 24.4062 2.5 23C2.5 21.6719 3.59375 20.5 5 20.5H5.625C7.96875 20.5 10 18.5469 10 16.125V15.5H5C2.1875 15.5 0 13.3125 0 10.5V5.5C0 2.76562 2.1875 0.5 5 0.5H10C12.7344 0.5 15 2.76562 15 5.5V8V10.5V16.125Z"
                            fill="#1B467D"
                          />
                        </svg>
                      </span>
                    </div>
                    <p className="text-primary-100 font-medium text-base leading-7">
                      "I no longer worry about OPD bills. The unlimited
                      consultation feature is a game-changer!"
                    </p>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="item sm:p-10 p-5 border border-primaryBorder rounded">
                    <div className="flex justify-between items-start mb-5">
                      <div className="flex space-x-5 items-center">
                        <div className="w-[80px] h-[80px] rounded-full">
                          <img
                            src="assets/img/testimonial-3.png"
                            alt=""
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center mb-2.5">
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                          </div>
                          <h2 className="text-gray-700 text-lg spline-sans font-semibold">
                            Dr. Meena Iyer
                          </h2>
                          <span className="text-base leading-7 text-primary-100 font-medium">
                            Pediatrician
                          </span>
                        </div>
                      </div>
                      <span className="sm:inline-block hidden">
                        <svg
                          width={35}
                          height={26}
                          viewBox="0 0 35 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M35 16.125C35 21.3594 30.7812 25.5 25.625 25.5H25C23.5938 25.5 22.5 24.4062 22.5 23C22.5 21.6719 23.5938 20.5 25 20.5H25.625C27.9688 20.5 30 18.5469 30 16.125V15.5H25C22.1875 15.5 20 13.3125 20 10.5V5.5C20 2.76562 22.1875 0.5 25 0.5H30C32.7344 0.5 35 2.76562 35 5.5V8V10.5V16.125ZM15 16.125C15 21.3594 10.7812 25.5 5.625 25.5H5C3.59375 25.5 2.5 24.4062 2.5 23C2.5 21.6719 3.59375 20.5 5 20.5H5.625C7.96875 20.5 10 18.5469 10 16.125V15.5H5C2.1875 15.5 0 13.3125 0 10.5V5.5C0 2.76562 2.1875 0.5 5 0.5H10C12.7344 0.5 15 2.76562 15 5.5V8V10.5V16.125Z"
                            fill="#1B467D"
                          />
                        </svg>
                      </span>
                    </div>
                    <p className="text-primary-100 font-medium text-base leading-7">
                      "As a medical professional, I can say their services are
                      top-notch and highly organized."
                    </p>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="item sm:p-10 p-5 border border-primaryBorder rounded">
                    <div className="flex justify-between items-start mb-5">
                      <div className="flex space-x-5 items-center">
                        <div className="w-[80px] h-[80px] rounded-full">
                          <img
                            src="assets/img/testimonial-4.png"
                            alt=""
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center mb-2.5">
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                          </div>
                          <h2 className="text-gray-700 text-lg spline-sans font-semibold">
                            Suresh Rathi
                          </h2>
                          <span className="text-base leading-7 text-primary-100 font-medium">
                            Business Owner
                          </span>
                        </div>
                      </div>
                      <span className="sm:inline-block hidden">
                        <svg
                          width={35}
                          height={26}
                          viewBox="0 0 35 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M35 16.125C35 21.3594 30.7812 25.5 25.625 25.5H25C23.5938 25.5 22.5 24.4062 22.5 23C22.5 21.6719 23.5938 20.5 25 20.5H25.625C27.9688 20.5 30 18.5469 30 16.125V15.5H25C22.1875 15.5 20 13.3125 20 10.5V5.5C20 2.76562 22.1875 0.5 25 0.5H30C32.7344 0.5 35 2.76562 35 5.5V8V10.5V16.125ZM15 16.125C15 21.3594 10.7812 25.5 5.625 25.5H5C3.59375 25.5 2.5 24.4062 2.5 23C2.5 21.6719 3.59375 20.5 5 20.5H5.625C7.96875 20.5 10 18.5469 10 16.125V15.5H5C2.1875 15.5 0 13.3125 0 10.5V5.5C0 2.76562 2.1875 0.5 5 0.5H10C12.7344 0.5 15 2.76562 15 5.5V8V10.5V16.125Z"
                            fill="#1B467D"
                          />
                        </svg>
                      </span>
                    </div>
                    <p className="text-primary-100 font-medium text-base leading-7">
                      "This is real value for money. I use their app for all my
                      employees and my family too. Highly Recommended!"
                    </p>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="item sm:p-10 p-5 border border-primaryBorder rounded">
                    <div className="flex justify-between items-start mb-5">
                      <div className="flex space-x-5 items-center">
                        <div className="w-[80px] h-[80px] rounded-full">
                          <img
                            src="assets/img/testimonial-5.png"
                            alt=""
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center mb-2.5">
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                          </div>
                          <h2 className="text-gray-700 text-lg spline-sans font-semibold">
                            Priya Menon
                          </h2>
                          <span className="text-base leading-7 text-primary-100 font-medium">
                            Software Engineer
                          </span>
                        </div>
                      </div>
                      <span className="sm:inline-block hidden">
                        <svg
                          width={35}
                          height={26}
                          viewBox="0 0 35 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M35 16.125C35 21.3594 30.7812 25.5 25.625 25.5H25C23.5938 25.5 22.5 24.4062 22.5 23C22.5 21.6719 23.5938 20.5 25 20.5H25.625C27.9688 20.5 30 18.5469 30 16.125V15.5H25C22.1875 15.5 20 13.3125 20 10.5V5.5C20 2.76562 22.1875 0.5 25 0.5H30C32.7344 0.5 35 2.76562 35 5.5V8V10.5V16.125ZM15 16.125C15 21.3594 10.7812 25.5 5.625 25.5H5C3.59375 25.5 2.5 24.4062 2.5 23C2.5 21.6719 3.59375 20.5 5 20.5H5.625C7.96875 20.5 10 18.5469 10 16.125V15.5H5C2.1875 15.5 0 13.3125 0 10.5V5.5C0 2.76562 2.1875 0.5 5 0.5H10C12.7344 0.5 15 2.76562 15 5.5V8V10.5V16.125Z"
                            fill="#1B467D"
                          />
                        </svg>
                      </span>
                    </div>
                    <p className="text-primary-100 font-medium text-base leading-7">
                      "Booking appointments and accessing reports digitally is
                      so convenient. Highly recommended!"
                    </p>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="item sm:p-10 p-5 border border-primaryBorder rounded">
                    <div className="flex justify-between items-start mb-5">
                      <div className="flex space-x-5 items-center">
                        <div className="w-[80px] h-[80px] rounded-full">
                          <img
                            src="assets/img/testimonial-6.png"
                            alt=""
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center mb-2.5">
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                            <span>
                              <svg
                                width={16}
                                height={15}
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.418 4.87891L14.3281 5.45312C14.6562 5.50781 14.9297 5.72656 15.0391 6.05469C15.1484 6.35547 15.0664 6.71094 14.8203 6.92969L11.9766 9.74609L12.6602 13.7383C12.7148 14.0664 12.5781 14.3945 12.3047 14.5859C12.0312 14.8047 11.6758 14.8047 11.375 14.668L7.875 12.7812L4.34766 14.668C4.07422 14.8047 3.69141 14.8047 3.44531 14.5859C3.17188 14.3945 3.03516 14.0664 3.08984 13.7383L3.74609 9.74609L0.902344 6.92969C0.65625 6.71094 0.574219 6.35547 0.683594 6.05469C0.792969 5.72656 1.06641 5.50781 1.39453 5.45312L5.33203 4.87891L7.08203 1.24219C7.21875 0.941406 7.51953 0.75 7.875 0.75C8.20312 0.75 8.50391 0.941406 8.64062 1.24219L10.418 4.87891Z"
                                  fill="#FFDF00"
                                />
                              </svg>
                            </span>
                          </div>
                          <h2 className="text-gray-700 text-lg spline-sans font-semibold">
                            Neeraj Deshpande
                          </h2>
                          <span className="text-base leading-7 text-primary-100 font-medium">
                            Retired Govt. Officer
                          </span>
                        </div>
                      </div>
                      <span className="sm:inline-block hidden">
                        <svg
                          width={35}
                          height={26}
                          viewBox="0 0 35 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M35 16.125C35 21.3594 30.7812 25.5 25.625 25.5H25C23.5938 25.5 22.5 24.4062 22.5 23C22.5 21.6719 23.5938 20.5 25 20.5H25.625C27.9688 20.5 30 18.5469 30 16.125V15.5H25C22.1875 15.5 20 13.3125 20 10.5V5.5C20 2.76562 22.1875 0.5 25 0.5H30C32.7344 0.5 35 2.76562 35 5.5V8V10.5V16.125ZM15 16.125C15 21.3594 10.7812 25.5 5.625 25.5H5C3.59375 25.5 2.5 24.4062 2.5 23C2.5 21.6719 3.59375 20.5 5 20.5H5.625C7.96875 20.5 10 18.5469 10 16.125V15.5H5C2.1875 15.5 0 13.3125 0 10.5V5.5C0 2.76562 2.1875 0.5 5 0.5H10C12.7344 0.5 15 2.76562 15 5.5V8V10.5V16.125Z"
                            fill="#1B467D"
                          />
                        </svg>
                      </span>
                    </div>
                    <p className="text-primary-100 font-medium text-base leading-7">
                      "At my age, regular check-ups are important. One Click
                      Doctor takes care of everything efficiently."
                    </p>
                  </div>
                </div>
              </div>
              <div className="swiper-pagination" />
              <div className="lg:flex hidden space-x-5 items-center absolute right-0 top-[45px]">
                <button
                  type="button"
                  className="swiper-button-prev flex justify-center items-center"
                >
                  <svg
                    width={16}
                    height={14}
                    viewBox="0 0 16 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="fill-[#1B467d]"
                  >
                    <path d="M1.29883 5.89453L6.61133 0.582031C7.00977 0.150391 7.70703 0.150391 8.10547 0.582031C8.53711 0.980469 8.53711 1.67773 8.10547 2.07617L4.61914 5.5625H14.8125C15.377 5.5625 15.875 6.06055 15.875 6.625C15.875 7.22266 15.377 7.6875 14.8125 7.6875H4.61914L8.10547 11.207C8.53711 11.6055 8.53711 12.3027 8.10547 12.7012C7.70703 13.1328 7.00977 13.1328 6.61133 12.7012L1.29883 7.38867C0.867188 6.99023 0.867188 6.29297 1.29883 5.89453Z" />
                  </svg>
                </button>
                <button
                  type="button"
                  className="swiper-button-next flex justify-center items-center"
                >
                  <svg
                    width={15}
                    height={14}
                    viewBox="0 0 15 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="fill-[#1B467d]"
                  >
                    <path d="M14.543 7.38867C14.9746 6.99023 14.9746 6.29297 14.543 5.89453L9.23047 0.582031C8.83203 0.150391 8.13477 0.150391 7.73633 0.582031C7.30469 0.980469 7.30469 1.67773 7.73633 2.07617L11.2227 5.5625H1.0625C0.464844 5.5625 0 6.06055 0 6.625C0 7.22266 0.464844 7.6875 1.0625 7.6875H11.2227L7.73633 11.207C7.30469 11.6055 7.30469 12.3027 7.73633 12.7012C8.13477 13.1328 8.83203 13.1328 9.23047 12.7012L14.543 7.38867Z" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pt-24 pb-[8rem]">
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-3xl font-bold leading-tight text-black sm:text-4xl lg:text-5xl">
               Not Convinced?
            </h2>
            <p className="max-w-lg mx-auto mt-4 text-base leading-relaxed text-gray-600">
             Take a look at some of our Clients
            </p>
          </div>
          
           <center className="min-md:px-[200px] mt-[80px]">
              <div className="swiper h3-partner_slider mt-11 overflow-hidden">
                <div className="swiper-wrapper">
                  <div className="swiper-slide" data-aos="fade">
                    <img src="assets/img/1.svg" alt="" />
                  </div>
                  <div
                    className="swiper-slide" data-aos="fade" data-aos-delay={100}
                  >
                    <img src="assets/img/2.svg" alt="" />
                  </div>
                  <div
                    className="swiper-slide" data-aos="fade" data-aos-delay={200}
                  >
                    <img src="assets/img/4.svg" alt="" />
                  </div>
                  <div
                    className="swiper-slide" data-aos="fade" data-aos-delay={300}
                  >
                    <img src="assets/img/5.svg" alt="" />
                  </div>
                  <div
                    className="swiper-slide" data-aos="fade" data-aos-delay={400}
                  >
                    <img src="assets/img/6.svg" alt="" />
                  </div>
                  <div
                    className="swiper-slide"data-aos="fade" data-aos-delay={500}
                  >
                    <img src="assets/img/7.svg" alt="" />
                  </div>
                  <div
                    className="swiper-slide"data-aos="fade" data-aos-delay={500}
                  >
                    <img src="assets/img/8.svg" alt="" />
                  </div>
                  <div
                    className="swiper-slide"data-aos="fade" data-aos-delay={500}
                  >
                    <img src="assets/img/9.png" alt=""  className="h-[60px]"/>
                  </div>
                  <div
                    className="swiper-slide"data-aos="fade" data-aos-delay={500}
                  >
                    <img src="assets/img/10.png" alt="" className="h-[60px]" />
                  </div>
                  <div
                    className="swiper-slide"data-aos="fade" data-aos-delay={500}
                  >
                    <img src="assets/img/11.png" alt="" className="h-[60px]" />
                  </div>
                  <div
                    className="swiper-slide"data-aos="fade" data-aos-delay={500}
                  >
                    <img src="assets/img/12.png" alt="" className="h-[60px]" />
                  </div>
                  <div
                    className="swiper-slide"data-aos="fade" data-aos-delay={500}
                  >
                    <img src="assets/img/13.svg" alt="" />
                  </div>
                  <div
                    className="swiper-slide"data-aos="fade" data-aos-delay={500}
                  >
                    <img src="assets/img/14.png" alt="" className="h-[60px]" />
                  </div>
                </div>
              </div>
            </center>
        </div>
      </section>
    </main>
  );
};

export default HomePage;
